import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './AppHero.css';

import * as sessionActions from '../actions/session-actions';
import isElectron from '../utils/is-electron';

import Button from './Button.js';
import RoomPickerModal from './RoomPickerModal.js';

class AppHero extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showRoomModal: false
    };

    this.runApp = this.runApp.bind(this);
    this.pickRoom = this.pickRoom.bind(this);
  }

  runApp() {
    this.setState({ showRoomModal: false });
    this.props.launch();
  }

  pickRoom() {
    this.setState({ showRoomModal: true });
  }

  renderRoomModal() {
    return <RoomPickerModal
      close={() => this.setState({ showRoomModal: false })}
      finish={() => this.runApp()} />
  }

  render() {
    let buttonClasses = ['AppHero__button Button--loader'];
    let buttonLabel = 'Launch!';

    if (this.props.running) {
      buttonClasses.push('disabled');
      buttonLabel = <span>Running! <span className="Button__help-label">(put on your Vive!)</span></span>;
    }

    return (
      <div className="AppHero">
        <div className="container">
          <div className="row">
            <div className="col-sm-8 col-sm-push-1 col-lg-6 col-lg-push-2">
              <h1 className="AppHero__header">Welcome back!</h1>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch)
  };
};

export default connect(null, mapDispatchToProps)(AppHero);



// WEBPACK FOOTER //
// ./src/components/AppHero.js